// extracted by mini-css-extract-plugin
export default {"ProfileOrganization":"ProfileOrganization_ProfileOrganization__BcFtC"};